import React, { useState, useEffect, useRef } from 'react';
import style from './MyInfoWithdraw.module.css';
import HeadSub from '../../../../components/comm/HeadSub';
import URL from "../../../../constants/url";
import { useNavigate } from "react-router-dom";
import Modal from "../../../../components/comm/Modal"
import imgChatbot from "../../../../images/user/i_chatbot_02.svg"
import { actionRemoveUser, reqDpRemoveUser } from '../../../../assets/js/comm';
import ToastPopup from '../../../../components/comm/ToastPopup';


const MyInfoWithdraw = () => {

    const loginUser = JSON.parse(sessionStorage.getItem('loginUser'));

    const navigate = useNavigate();

    //체크박스
    const [check, setCheck] = useState(false);

    //토스트메시지
    const [toast, setToast] = useState(false);
    const [toastMessage, setToastMessage] = useState('');

    //모달창
    const [isOpen, setIsOpen] = useState(false);

    const withdrawBtn = ()=> {
        if(!check) {
            setToastMessage("안내사항에 동의해야 탈퇴하기가 가능합니다.");
            setToast(true);
            return;
        }
        setIsOpen(!isOpen);
    };

    const handleCheck = (e) => {
        const checked = e.target.checked;
        setCheck(checked);
    };

    const handleWithdraw = async () => {
        if(!check) {
            setToastMessage("안내사항에 동의해야 탈퇴하기가 가능합니다.");
            setToast(true);
            return;
        }

        await reqDpRemoveUser(loginUser.usrUid)
            .then( res => {
                setToastMessage("탈퇴처리 완료 되었습니다.");
                setToast(true);
                setIsOpen(false);
                actionRemoveUser(loginUser);

            })
            .catch( err => {
                console.log(err);
                //actionRemoveUser(loginUser);// 에러가 난 경우는 보통.. 이미 삭제된 경우이니, 애프터케어 서비스도 탈퇴처리.. 필요시..
                setToastMessage("탈퇴처리중 오류가 발생하였습니다. 로그인화면으로 이동합니다.");
                setToast(true);
                // actionRemoveUser 를 걸어주면 아래 코드들은 콘솔로그 전까지 삭제 할것!
                localStorage.removeItem("jToken");
                localStorage.removeItem("AFTCR_CRTFC_TKN");
                sessionStorage.clear();
                // 같은 창에서 마운트된 ProtectedRoute에 변경 알림
                window.dispatchEvent(new Event("auth-changed"));
                // 현재 탈퇴 페이지 항목을 교체하며 메인으로 이동
                window.location.replace(URL.MAIN);
            })
    };

    return (
        <>
            <HeadSub title="탈퇴하기" />

            <div id="sub-content" data-layout="white">
                <div className="inner-wrap">

                <div className={style['mid-box']}>
                        <div className={style['top']}>
                            <object data={imgChatbot} className='ani-float' aria-hidden='true'></object>
                        </div>
                        <div className={style['mid']}>
                            <strong>탈퇴안내</strong>
                        </div>
                        <div className={style['botm']}>
                            <ul>
                                <li>
                                    <p>탈퇴 시 회원님의 계정 정보와 개인 데이터는 모두 삭제됩니다.</p>
                                </li>
                                <li>
                                    <p>탈퇴 이후에는 계정 및 데이터 복구가 불가능합니다.</p>
                                </li>
                                <li>
                                    <p>문의/오류 제보 게시물은 관련 법령에 따라 최대 3년간 보관 후 삭제됩니다.</p>
                                </li>
                            </ul>
                        </div>

                    </div>


                    {/* 하단 다음 버튼 영역 :: S */}
                    <div className="bottom-fixed-box" data-height="auto">
                        <div className="inner-box">
                            <div className='btn-layout' data-btn-num="1" data-btn-direction="column">

                            <div className='chkbox-custom m-r-auto' data-chkbox='basic'>
                                    <input type="checkbox" id='chkId'
                                           checked={check}
                                           onChange={handleCheck}
                                    />
                                    <label htmlFor="chkId">
                                        <div className={style['txt-box']}>
                                            <p>안내 사항을 모두 읽고 이해했습니다.</p>
                                        </div>
                                    </label>
                                </div>
                                <button className="btn" data-btn-type="fill-main" data-btn-size="lg" onClick={withdrawBtn}>
                                    <span>탈퇴하기</span>
                                </button>

                            </div>
                        </div>
                    </div>
                    {/* 하단 다음 버튼 영역 :: E */}

                </div>
            </div>


            <Modal isOpen={isOpen} setIsOpen={setIsOpen}>
                <div className='modal-box' data-type="a">
                    <div className='modal-top-box'>
                        <div className='title-box'>
                            <p> 정말 탈퇴하실 건가요?</p>
                        </div>
                        <div className='sub-box'>
                            <span>
                               탈퇴신청을 하면 되돌릴 수 없습니다.
                            </span>
                        </div>
                    </div>

                    <div className="modal-bottom-box">
                        <div className='btn-layout'>
                            <button className="btn" data-btn-type="fill-gray" data-btn-size="md" onClick={() => setIsOpen(false)}>
                                <span>아니오</span>
                            </button>
                            <button className="btn" data-btn-type="fill-main" data-btn-size="md" onClick={handleWithdraw}>
                                <span>탈퇴하기</span>
                            </button>
                        </div>
                    </div>
                </div>
            </Modal>

            {toast && (
                <ToastPopup
                    setToast={setToast}
                    message={toastMessage}
                    position="center"
                    opacity="90"
                />
            )}
        </>
    );
};

export default MyInfoWithdraw;
